<template>
  <transition>
    <a v-if="isA" class="btn btn-link" :class="[btnclass, customClass]" :style="btnstyle" :href="href" @click="handleClick($event)" :disabled="btndisabled" v-waves>
      <i v-if="icon && !isLoading" class="fa" :class="iconclass"></i>
      <i v-if="isLoading" class="fa fa-spinner fa-pulse"></i>
      <slot></slot>
    </a>
    <button v-else :type="typeNative" class="btn" :class="[btnclass, customClass]" :style="btnstyle" @click="handleClick($event)" :disabled="btndisabled" v-waves>
      <i v-if="icon && !isLoading" class="fa" :class="iconclass"></i>
      <i v-if="isLoading" class="fa fa-spinner fa-pulse"></i>
      <slot></slot>
    </button>
  </transition>
</template>

<script>
export default {
  name: 'JyButton',
  componentName: 'JyButton',
  props: {
    icon: String,
    type: {
      type: String,
      default: 'secondary'
    },
    size: String,
    customClass: {
      type: String,
      default: ''
    },
    typeNative: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    isBlock: Boolean,
    isOutline: Boolean,
    pl: Number,
    pt: Number,
    width: [String, Number],
    isLoading: Boolean,
    isA: Boolean,
    href: {
      type: String,
      default: 'javascript:;'
    }
  },
  computed: {
    btnclass() {
      let typeclass = '';
      if (!this.isA) {
        typeclass = this.type ? ('btn-'+ (this.isOutline ? 'outline-' : '') + this.type) : '';
      }
      let sizeclass = this.size ? ('btn-'+ this.size) : '';
      // let blockclass = this.isBlock ? 'btn-block' : '';
      return typeclass +' '+ sizeclass;
    },
    iconclass() {
      return this.icon ? ('fa-'+ this.icon) : ''
    },
    btnstyle() {
      let style = {};
      if (this.pl) {
        style['padding-left'] = this.pl +'rem';
        style['padding-right'] = this.pl +'rem';
      }
      if (this.pt) {
        style['padding-left'] = this.pt +'rem';
        style['padding-right'] = this.pt +'rem';
      }
      if (this.width) {
        style['width'] = this.width +'rem';
        if (style['width'].indexOf('%') > 0) {
          style['width'] = style['width'].replace('rem', '')
        }
      }
      return style;
    },
    btndisabled() {
      return this.disabled || this.isLoading ? true : false;
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    }
  }
}
</script>

<style>
.btn{line-height:1.35;}
.btn i{padding-right:.2rem;}
.btn i.fa-pulse{padding-right:0; margin:0;}
@media (max-width: 575.98px) {
  .btn-xs-sm{padding: 0.25rem 0.5rem; font-size: 0.875rem; line-height: 1.3; border-radius: 0.2rem;}
}
</style>
